import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FavoriteRoute } from 'src/app/modules/route-planner/interfaces/favorites/favorite-route.interface';

@Component({
    selector: 'app-favorite-route',
    templateUrl: './favorite-route.component.html',
    styleUrls: ['./favorite-route.component.scss'],
    standalone: false
})
export class FavoriteRouteComponent {
  @Output() onEditButtonClick = new EventEmitter<void>();
  @Output() onDeleteButtonClick = new EventEmitter<void>();
  @Output() onPickFavoriteClick = new EventEmitter<void>();

  @Input() showActionButtons: boolean = false;
  @Input() route: FavoriteRoute;
  /** a11y: accessible names for the pen/trash icon buttons (audit). */
  @Input() editAriaLabel: string = '';
  @Input() deleteAriaLabel: string = '';
}
